import React, { useState, Fragment } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutOne from "../../layouts/LayoutOne";
import api from "../../api";
import toast from "react-hot-toast";

const ResetPassword = () => {
  const { pathname } = useLocation();
  const { uidb64, token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await api.post(`users/reset-password/${uidb64}/${token}/`, {
        new_password: newPassword,
      });
      toast.success("Password reset successful! Redirecting to login...");
      setTimeout(() => navigate("/login-register"), 2000);
    } catch (err) {
      toast.error(err.response?.data?.error || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <LayoutOne headerTop="visible">
        <div className="login-register-area pt-100 pb-100">
          <div className="container">
            <div className="row">
              <div className="ms-auto me-auto col-lg-6">
                <div className="login-register-wrapper text-center p-4 shadow-sm rounded-3 bg-white">
                  <h3 className="mb-4">Reset Password</h3>

                  <form onSubmit={handleSubmit} className="text-start">
                    <div className="mb-3">
                      <label className="form-label">New Password</label>
                      <input
                        type="password"
                        className="form-control border rounded-3 shadow-none"
                        placeholder="Enter your new password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        style={{ backgroundColor: "transparent" }}
                      />
                    </div>

                    <button
                      type="submit"
                      disabled={loading}
                      className="w-100 btn rounded-3 py-2 mt-2"
                      style={{
                        border: "none",
                        fontWeight: "500",
                        transition: "0.3s",
                      }}
                    >
                      {loading ? "Resetting..." : "Reset Password"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

export default ResetPassword;
